import * as React from "react";
import { cn } from "@/lib/utils";

const sizes = {
  sm: "max-w-2xl",
  md: "max-w-4xl",
  lg: "max-w-6xl",
  xl: "max-w-7xl",
  /** Mirrors Tailwind's responsive `container` breakpoints (ending at 1400px). */
  wide: "max-w-full sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1024px] xl:max-w-[1280px] 2xl:max-w-[1400px]",
  full: "max-w-none",
} as const;

export type ContainerSize = keyof typeof sizes;

export interface ContainerProps extends React.HTMLAttributes<HTMLElement> {
  /** Max width: sm 672px · md 896px · lg 1152px · xl 1280px · wide responsive to 1400px · full. */
  size?: ContainerSize;
  /** Horizontal page gutters (16px → 24px → 32px). Default true. */
  padded?: boolean;
  as?: React.ElementType;
}

/** Centered, responsive content column. Wrap every page body in one. */
export function Container({
  size = "lg",
  padded = true,
  as: Component = "div",
  className,
  ...props
}: ContainerProps) {
  return (
    <Component
      className={cn("mx-auto w-full", sizes[size], padded && "px-4 sm:px-6 lg:px-8", className)}
      {...props}
    />
  );
}
